

import React, { useState, useEffect, useRef } from 'react'
import { Link } from "react-router-dom";
import { Radio, Select, Col, Row, Input, Checkbox } from "antd";
import backButton from '../../../../assets/images/back_button_arrow.svg';
import siteIcon from '../../../../assets/images/icons/site.svg';
import axios from "axios";
import { notifysuccess } from "../../../../utils/toast";
import { notifyfailure } from "../../../../utils/toast";
import { notifycatch } from "../../../../utils/toast";
import Cookies from "js-cookie";
import configData from "../../../../config/config.json";
import loaderIcon from "../../../../assets/images/login-and-signup/loader.gif";
import { SearchOutlined } from '@ant-design/icons';
import demandIcon from '../../../../assets/images/icons/demand_icon.svg';
const { Option } = Select;

const TagCreatePubmatic = ({ handlePageViewChange, handlePageViewEditBreadcrum, siteViewId, siteViewName }) => {



    const scrollToItem = (ref, offset = 80) => {
        if (ref && ref.current) {
            ref.current.style.scrollMarginTop = `${offset}px`;
            ref.current.scrollIntoView({ behavior: "smooth", block: "start" });
            setTimeout(() => {
                ref.current.style.scrollMarginTop = '';
            }, 500);
        }
    };

    useEffect(() => {
        if (siteViewId !== "" && siteViewName !== "") {
            setSite_pubmatic(siteViewId)

            axios
                .get(configData.SERVER_URL + "ops/pubmatic/adSize?siteId=" + siteViewId, {
                    headers: {
                        "Content-Type": "application/json",
                    },
                })
                .then((response) => {
                    setAdSizePrimaryOptions_pubmatic(response.data.data)
                    setAdSizeAdditionalOptions_pubmatic(response.data.data)
                })
                .catch((error) => { });
        }
    }, [])

    useEffect(() => {
        const inputs = document.querySelectorAll('.ant-select-selection-search-input');

        inputs.forEach(input => {
            const handleInput = () => {
                const parent = input.closest('.ant-select-selection-search');
                if (input.value.length > 0) {
                    parent.classList.add('searching');
                } else {
                    parent.classList.remove('searching');
                }
            };

            input.addEventListener('input', handleInput);

            // Cleanup event listener on component unmount
            return () => {
                input.removeEventListener('input', handleInput);
            };
        });
    });


    const [buttonProcessing, setButtonProcessing] = useState(false);


    const [site_pubmatic, setSite_pubmatic] = useState("");
    const [siteIsRequiredError_pubmatic, setSiteIsRequiredError_pubmatic] = useState(false);
    const [siteOptions_pubmatic, setSiteOptions_pubmatic] = useState([]);

    useEffect(() => {

        axios
            .get(configData.SERVER_URL + "ops/pubmatic/siteMinifiedList", {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                setSiteOptions_pubmatic(response.data.data)
            })
            .catch((error) => { });

        axios
            .get(configData.SERVER_URL + "ops/pubmatic/videoMimeTypeList", {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                setMmeTypeOptions_pubmatic(response.data.data)
            })
            .catch((error) => { });




    }, [])

    function onChangeSite_pubmatic(event) {
        setSiteIsRequiredError_pubmatic(false)
        setSite_pubmatic(event);

        axios
            .get(configData.SERVER_URL + "ops/pubmatic/adSize?siteId=" + event, {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                setAdSizePrimaryOptions_pubmatic(response.data.data)
                setAdSizeAdditionalOptions_pubmatic(response.data.data)
            })
            .catch((error) => { });
    }


    const [formatType_pubmatic, setFormatType_pubmatic] = useState("13");
    const [formatTypeOptions_pubmatic] = useState([{ label: "Video", value: "13" },
    { label: "Banner/Rich Media", value: "3" }
    ]);


    function onChangeFormatType_pubmatic(event) {
        setFormatType_pubmatic(event);
        if (event === "13") {
            resetBannerRichMedia()
            resetVideo()
        }
        else {
            resetVideo()
            resetBannerRichMedia()
        }

    }

    function resetVideo() {
        setResponseCode_pubmatic("3")
        setTagName_pubmatic("")
        setTagNameIsRequiredError_pubmatic(false)

        setProtocol_pubmatic("2")

        setMmeType_pubmatic([1, 5, 7]);
        setMmeTypeIsRequiredError_pubmatic(false);
        setSearchValueMmeType('');

        setMinAd("0");
        setMinAdIsRequiredError(false);
        setMinAdValueRangeError(false);

        setMaxAd("120");
        setMaxAdIsRequiredError(false);
        setMaxAdValueError(false);
        setMaxAdValueRangeError(false);
    }

    function resetBannerRichMedia() {
        setResponseCode_pubmatic("1")
        setTagName_pubmatic("")
        setTagNameIsRequiredError_pubmatic(false)
        setAdSizePrimary_pubmatic(9);
        setAdSizeAdditional_pubmatic([]);
        setAdSizeAdditionalValidError_pubmatic(false)
        setSearchValueAdSizeAdditional('');
    }

    // --------------------------------------------------commom code -----------------------------------------------------//

    const [responseCode_pubmatic, setResponseCode_pubmatic] = useState("3");

    function onChangeResponseCode_pubmatic(event) {
        setResponseCode_pubmatic(event.target.value);
    }

    const [tagName_pubmatic, setTagName_pubmatic] = useState("");
    const [tagNameIsRequiredError_pubmatic, setTagNameIsRequiredError_pubmatic] = useState(false);

    function onChangeTagName_pubmatic(event) {
        setTagNameIsRequiredError_pubmatic(false);
        setTagName_pubmatic(event.target.value);

        if (event.target.value.length === 0) {
            setTagNameIsRequiredError_pubmatic(true);
        }
    }

    function onBlurTagName_pubmatic(event) {
        if (event.target.value.trim().length === 0) {
            setTagNameIsRequiredError_pubmatic(true);
        }
        setTagName_pubmatic(event.target.value.trim());
    }


    // --------------------------------------------------Video code -----------------------------------------------------//

    const [protocol_pubmatic, setProtocol_pubmatic] = useState("2");

    function onChangeProtocol_pubmatic(event) {
        setProtocol_pubmatic(event.target.value);
    }


    const [mmeType_pubmatic, setMmeType_pubmatic] = useState([1, 5, 7]);
    const [mmeTypeIsRequiredError_pubmatic, setMmeTypeIsRequiredError_pubmatic] = useState(false);
    const [mmeTypeOptions_pubmatic, setMmeTypeOptions_pubmatic] = useState([]);


    const [searchValueMmeType, setSearchValueMmeType] = useState('');

    const handleSearchMmeType = (e) => {
        setSearchValueMmeType(e.target.value.toLowerCase());
    };

    const filteredOptionsMmeType = mmeTypeOptions_pubmatic.filter(option =>
        option.label.toLowerCase().includes(searchValueMmeType)
    );



    function handleChangeMmeType(value) {
        let tempMmeType_pubmatic = [...mmeType_pubmatic]

        let newValue = [];
        if (tempMmeType_pubmatic.includes(value)) {
            newValue = tempMmeType_pubmatic.filter((item) => item !== value);
        } else {
            newValue = [...tempMmeType_pubmatic, value];
        }
        tempMmeType_pubmatic = newValue

        if (tempMmeType_pubmatic.length === 0) {
            setMmeTypeIsRequiredError_pubmatic(true)
        }
        else {
            setMmeTypeIsRequiredError_pubmatic(false)
        }

        setMmeType_pubmatic(tempMmeType_pubmatic)
    }

    function handleSelectAllMmeType() {
        const allValues = mmeTypeOptions_pubmatic.map(option => option.value);
        let tempMmeType_pubmatic = [];
        if (mmeType_pubmatic?.length !== mmeTypeOptions_pubmatic?.length) {
            tempMmeType_pubmatic = [...allValues];
            setMmeTypeIsRequiredError_pubmatic(false)
        } else {
            tempMmeType_pubmatic = [];
            setMmeTypeIsRequiredError_pubmatic(true)
        }


        setMmeType_pubmatic(tempMmeType_pubmatic);
    }




    const [minAd, setMinAd] = useState("1");
    const [minAdIsRequiredError, setMinAdIsRequiredError] = useState(false);
    const [minAdValueRangeError, setMinAdValueRangeError] = useState(false);
    function onChangeMinAd(event) {
        if (/^\d*$/.test(event.target.value.trim())) {
            setMinAd(event.target.value.trim());
        }

        if (maxAd === "") {
            setMaxAdValueError(false)
        }
        else {
            if (event.target.value.trim() !== "") {


                if (Number(maxAd) < Number(event.target.value)) {
                    setMaxAdValueError(true)
                }
                else {
                    setMaxAdValueError(false)
                }
            }
        }

        if (event.target.value.trim() === "") {
            setMaxAdValueError(false)
            setMinAdValueRangeError(false)
            setMinAdIsRequiredError(true)
        }
        else {
            setMinAdIsRequiredError(false)
        }

        if (event.target.value.trim()?.length > 0) {
            if (Number(event.target.value.trim()) >= 1 && Number(event.target.value.trim()) <= 500) {
                setMinAdValueRangeError(false)
            }
            else {
                setMinAdValueRangeError(true)
            }
        }
    }


    const [maxAd, setMaxAd] = useState("120");
    const [maxAdIsRequiredError, setMaxAdIsRequiredError] = useState(false);
    const [maxAdValueError, setMaxAdValueError] = useState(false);
    const [maxAdValueRangeError, setMaxAdValueRangeError] = useState(false);

    function onChangeMaxAd(event) {
        if (/^\d*$/.test(event.target.value.trim())) {
            setMaxAd(event.target.value.trim());
        }

        if (minAd === "") {
            setMaxAdValueError(false)
        }
        else {
            if (event.target.value.trim() !== "") {

                if (Number(minAd) > Number(event.target.value)) {
                    setMaxAdValueError(true)
                }
                else {
                    setMaxAdValueError(false)
                }
            }
        }

        if (event.target.value.trim() === "") {
            setMaxAdValueError(false)
            setMaxAdValueRangeError(false)
            setMaxAdIsRequiredError(true)
        }
        else {
            setMaxAdIsRequiredError(false)
        }

        if (event.target.value.trim()?.length > 0) {
            if (Number(event.target.value.trim()) >= 1 && Number(event.target.value.trim()) <= 500) {
                setMaxAdValueRangeError(false)
            }
            else {
                setMaxAdValueRangeError(true)
            }
        }
    }






    // --------------------------------------------------Banner / Richmedia code -----------------------------------------------------//

    const [adSizePrimary_pubmatic, setAdSizePrimary_pubmatic] = useState(9);
    const [adSizePrimaryOptions_pubmatic, setAdSizePrimaryOptions_pubmatic] = useState([{
        "label": "300x250 - Sidekick",
        "value": 9
    }]);

    function onChangeAdSizePrimary_pubmatic(event) {
        setAdSizePrimary_pubmatic(event);
        setAdSizeAdditional_pubmatic([])
    }



    const [adSizeAdditional_pubmatic, setAdSizeAdditional_pubmatic] = useState([]);
    const [adSizeAdditionalOptions_pubmatic, setAdSizeAdditionalOptions_pubmatic] = useState([]);
    const [adSizeAdditionalValidError_pubmatic, setAdSizeAdditionalValidError_pubmatic] = useState(false);


    const [searchValueAdSizeAdditional, setSearchValueAdSizeAdditional] = useState('');

    const handleSearchAdSizeAdditional = (e) => {
        setSearchValueAdSizeAdditional(e.target.value.toLowerCase());
    };

    const filteredOptionsAdSizeAdditional = adSizeAdditionalOptions_pubmatic.filter(option => option.value !== adSizePrimary_pubmatic).filter(option =>
        option.label.toLowerCase().includes(searchValueAdSizeAdditional)
    );



    function handleChangeAdSizeAdditional(value) {
        let tempAdSizeAdditional_pubmatic = [...adSizeAdditional_pubmatic]

        let newValue = [];
        if (tempAdSizeAdditional_pubmatic.includes(value)) {
            newValue = tempAdSizeAdditional_pubmatic.filter((item) => item !== value);
        } else {
            newValue = [...tempAdSizeAdditional_pubmatic, value];
        }
        tempAdSizeAdditional_pubmatic = newValue


        if (tempAdSizeAdditional_pubmatic.length > 9) {
            setAdSizeAdditionalValidError_pubmatic(true)
        }
        else {
            setAdSizeAdditionalValidError_pubmatic(false)
        }

        setAdSizeAdditional_pubmatic(tempAdSizeAdditional_pubmatic)
    }

    function handleSelectAllAdSizeAdditional() {
        const allValues = adSizeAdditionalOptions_pubmatic.map(option => option.value);
        let temp_pubmatic = [];
        if (adSizeAdditional_pubmatic?.length !== adSizeAdditionalOptions_pubmatic?.length) {
            temp_pubmatic = [...allValues];

        } else {
            temp_pubmatic = [];
        }


        setAdSizeAdditional_pubmatic(temp_pubmatic);
    }





    //-----------------------------------------------------------------------------------------------------------------------//

    const site_pubmatic_ref = useRef(null)

    const errorDetect = () => {

        if (site_pubmatic === "" || siteIsRequiredError_pubmatic) {
            scrollToItem(site_pubmatic_ref);
            return
        }

        // if (formatType_pubmatic === "13") {


        // }

        // if (formatType_pubmatic === "3") {

        // }

    }



    const handleSubmit = async (e) => {
        e.preventDefault();

        errorDetect()

        if (formatType_pubmatic === "3") {

            if (
                site_pubmatic !== "" &&
                tagName_pubmatic.trim() !== ""
            ) {
                if (
                    siteIsRequiredError_pubmatic === false &&
                    tagNameIsRequiredError_pubmatic === false &&
                    adSizeAdditionalValidError_pubmatic === false
                ) {


                    let payload =
                    {
                        site: site_pubmatic,
                        formatType: Number(formatType_pubmatic),
                        responseCode: Number(responseCode_pubmatic),
                        primaryAdSize: adSizePrimary_pubmatic,
                        additionalAdSize: adSizeAdditional_pubmatic,
                        tagName: tagName_pubmatic.trim()
                    }

                    setButtonProcessing(true)

                    let status = Cookies.get("token_xapads_ssp") ? true : false;
                    if (status) {
                        let token = Cookies.get("token_xapads_ssp");

                        axios
                            .post(configData.SERVER_URL + `ops/pubmatic/createTag`, payload, {
                                headers: {
                                    'Content-Type': 'application/json',
                                    "x-access-token": token,
                                },
                            })
                            .then((response) => {
                                notifysuccess(response.data.message);
                                setTimeout(() => {
                                    handlePageViewChange("table", "yes")
                                }, 1000)

                            })
                            .catch((error) => {
                                if (error?.response) {
                                    if (error.response.data.message?.length !== 0) {
                                        notifyfailure(error.response.data.message);
                                        setButtonProcessing(false)
                                    }
                                } else {
                                    notifycatch();
                                    setButtonProcessing(false)
                                }

                            });
                    }


                }
            } else {

                if (site_pubmatic === "") {
                    setSiteIsRequiredError_pubmatic(true);
                }

                if (tagName_pubmatic.trim() === "") {
                    setTagNameIsRequiredError_pubmatic(true);
                }
            }
        }

        if (formatType_pubmatic === "13") {

            if (
                site_pubmatic !== "" &&
                tagName_pubmatic.trim() !== "" &&
                minAd !== "" &&
                maxAd !== "" &&
                mmeType_pubmatic.length !== 0
            ) {
                if (
                    siteIsRequiredError_pubmatic === false &&
                    tagNameIsRequiredError_pubmatic === false &&
                    minAdIsRequiredError === false &&
                    minAdValueRangeError === false &&
                    maxAdIsRequiredError === false &&
                    maxAdValueError === false &&
                    maxAdValueRangeError === false &&
                    mmeTypeIsRequiredError_pubmatic === false
                ) {


                    let payload =
                    {
                        site: site_pubmatic,
                        formatType: Number(formatType_pubmatic),
                        responseCode: Number(responseCode_pubmatic),
                        protocol: Number(protocol_pubmatic),
                        minAdDuration: Number(minAd),
                        maxAdDuration: Number(maxAd),
                        mmeType: mmeType_pubmatic,
                        tagName: tagName_pubmatic.trim()
                    }

                    setButtonProcessing(true)

                    let status = Cookies.get("token_xapads_ssp") ? true : false;
                    if (status) {
                        let token = Cookies.get("token_xapads_ssp");

                        axios
                            .post(configData.SERVER_URL + `ops/pubmatic/createTag`, payload, {
                                headers: {
                                    'Content-Type': 'application/json',
                                    "x-access-token": token,
                                },
                            })
                            .then((response) => {
                                notifysuccess(response.data.message);
                                setTimeout(() => {
                                    handlePageViewChange("table", "yes")
                                }, 1000)

                            })
                            .catch((error) => {
                                if (error?.response) {
                                    if (error.response.data.message?.length !== 0) {
                                        notifyfailure(error.response.data.message);
                                        setButtonProcessing(false)
                                    }
                                } else {
                                    notifycatch();
                                    setButtonProcessing(false)
                                }

                            });
                    }


                }
            } else {

                if (site_pubmatic === "") {
                    setSiteIsRequiredError_pubmatic(true);
                }

                if (tagName_pubmatic.trim() === "") {
                    setTagNameIsRequiredError_pubmatic(true);
                }

                if (minAd === "") {
                    setMinAdIsRequiredError(true);
                }

                if (maxAd === "") {
                    setMaxAdIsRequiredError(true);
                }
                if (mmeType_pubmatic.length === 0) {
                    setMmeTypeIsRequiredError_pubmatic(true);
                }
            }
        }
    }



    return (
        <>
            <div className="container_box--wrapper pt_header">
                <div className="container_box--breadcrumb">
                    <ul className="container_box--breadcrumb-list">

                        <li >
                            <Link onClick={() => {
                                handlePageViewEditBreadcrum("table", "sites")
                            }}>
                                <img src={demandIcon} alt='USP' />
                                Pubmatic
                            </Link>
                        </li>
                        <li>
                            <Link onClick={() => {
                                handlePageViewChange("table", "no")
                            }}>

                                Tags
                            </Link>
                        </li>
                        <li className="primary">New Tag</li>
                    </ul>
                </div>
                <div className="container_box--wrapper--title d_flex justify-content-between">
                    <div className="back_btn_d2">
                        <img src={backButton} className="img-fluid" alt=""
                            onClick={() => {
                                handlePageViewChange("table", "no")

                            }}
                        />
                        <h1 className="heading">
                            Create Tag
                        </h1>
                    </div>
                </div>
                <div className="container_box--content pt_20">
                    <div className="container_box--width">

                        <Row gutter={16}>
                            <Col span={8}>
                                <div className="container_box--label-info">
                                    <label>Configuration Details</label>
                                    <p className="sub_text">Select site and format.</p>
                                </div>
                            </Col>

                            <Col span={16}>
                                <div className="container_box--form-container">
                                    <Row gutter={16}>
                                        <Col span={24}>
                                            <div className="form_content_block--group  hide_caret_after_select_value" ref={site_pubmatic_ref}>
                                                <label className="form_label">Site/App * </label>
                                                <Select
                                                    showSearch
                                                    className={siteIsRequiredError_pubmatic ? 'form_select basic  error' : 'form_select basic '}
                                                    placeholder="-Select-"
                                                    optionFilterProp="label"
                                                    onChange={onChangeSite_pubmatic}
                                                    value={site_pubmatic}
                                                    options={siteOptions_pubmatic}
                                                    disabled={siteViewId !== "" && siteViewName !== ""}
                                                />
                                                <span className="error_content">{siteIsRequiredError_pubmatic && <>This field is required</>} </span>
                                            </div>
                                            <div className="form_content_block--group  hide_caret_after_select_value">
                                                <label className="form_label">Format Type * </label>
                                                <Select
                                                    showSearch
                                                    className='form_select basic no_search'
                                                    placeholder="-Select-"
                                                    optionFilterProp="label"
                                                    onChange={onChangeFormatType_pubmatic}
                                                    value={formatType_pubmatic}
                                                    options={formatTypeOptions_pubmatic}
                                                />
                                                <span className="error_content"> </span>
                                            </div>
                                            <div className="form_content_block--group mb-0">
                                                <label className="form_label">
                                                    Response Code *
                                                </label>
                                                {formatType_pubmatic === "13" ?
                                                    <Radio.Group className="form_radio equal_space"
                                                        value={responseCode_pubmatic}
                                                        onChange={onChangeResponseCode_pubmatic}
                                                    >
                                                        <Radio className="radio_btn" value="3">
                                                            VAST
                                                        </Radio>
                                                    </Radio.Group>
                                                    :
                                                    <Radio.Group className="form_radio equal_space"
                                                        value={responseCode_pubmatic}
                                                        onChange={onChangeResponseCode_pubmatic}
                                                    >
                                                        <Radio className="radio_btn" value="1">
                                                            JavaScript
                                                        </Radio>
                                                        <Radio className="radio_btn" value="0">
                                                            Iframe
                                                        </Radio>
                                                        <Radio className="radio_btn" value="2">
                                                            HTML 5
                                                        </Radio>
                                                    </Radio.Group>
                                                }


                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>

                        {formatType_pubmatic === "13" ?
                            <Row gutter={16}>
                                <Col span={8}>
                                    <div className="container_box--label-info">
                                        <label>Video Preferences</label>
                                    </div>
                                </Col>

                                <Col span={16}>
                                    <div className="container_box--form-container">
                                        <div className="form_content_block--group">
                                            <label className="form_label">
                                                Protocol
                                            </label>
                                            <Radio.Group className="form_radio equal_space"
                                                value={protocol_pubmatic}
                                                onChange={onChangeProtocol_pubmatic}
                                            >
                                                <Radio className="radio_btn" value="2">
                                                    VAST 2.0
                                                </Radio>
                                                <Radio className="radio_btn" value="3">
                                                    VAST 3.0
                                                </Radio>
                                                <Radio className="radio_btn" value="8">
                                                    VAST 4
                                                </Radio>
                                            </Radio.Group>
                                        </div>
                                        <div className="form_content_block--group">
                                            <div className='checkbox_value_select_d2 multi_select_tag_d2'>
                                                <label className="form_label">MIME Types * </label>
                                                <Select
                                                    id="mmeType"
                                                    value={mmeType_pubmatic}
                                                    popupClassName='diff_select_d2 --full'
                                                    // open={true}
                                                    showSearch={false}
                                                    placeholder='- Select -'
                                                    className={mmeTypeIsRequiredError_pubmatic ? "form_select basic error" : "form_select basic"}
                                                    mode='multiple'
                                                    maxTagCount='responsive'
                                                    dropdownRender={menu => (
                                                        <>
                                                            <div className="custom_inside_searchbar_d2">
                                                                <Input placeholder="Search"
                                                                    value={searchValueMmeType} onChange={handleSearchMmeType}
                                                                    prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                            </div>
                                                            <div className='select_all_d2'
                                                                onClick={() => handleSelectAllMmeType()}
                                                            >
                                                                <Checkbox checked={mmeType_pubmatic?.length === mmeTypeOptions_pubmatic?.length} onClick={(e) => e.stopPropagation()}>
                                                                    Select All
                                                                </Checkbox>
                                                            </div>
                                                            {menu}
                                                        </>
                                                    )}
                                                >
                                                    {[
                                                        ...filteredOptionsMmeType?.filter(option => mmeType_pubmatic?.includes(option.value)), // Checked options first
                                                        ...filteredOptionsMmeType?.filter(option => !mmeType_pubmatic?.includes(option.value)) // Unchecked options next
                                                    ].map(option => (
                                                        <Option key={option.value} value={option.value}>
                                                            <div
                                                                onClick={() => handleChangeMmeType(option.value)}
                                                                style={{ display: 'flex', alignItems: 'center' }}
                                                            >
                                                                <Checkbox
                                                                    checked={mmeType_pubmatic.includes(option.value)}
                                                                    onClick={(e) => e.stopPropagation()}
                                                                >
                                                                    {option.label}
                                                                </Checkbox>
                                                            </div>
                                                        </Option>
                                                    ))}
                                                </Select>
                                                <span className="error_content"> {mmeTypeIsRequiredError_pubmatic && <>Minimum 1 selection is required</>}
                                                </span>
                                            </div>
                                        </div>
                                        <Row gutter={16}>
                                            <Col span={12} className='position-relative'>
                                                <div className="form_content_block--group mb_0">
                                                    <label className="form_label">Ad Duration *</label>
                                                    <Input className={minAdIsRequiredError || minAdValueRangeError ? 'form_control basic error' : 'form_control basic'} autocomplete="off" placeholder='From' suffix={
                                                        <em className='input_inside_text_d2'>second(s)</em>
                                                    }
                                                        value={minAd}
                                                        onChange={onChangeMinAd}
                                                    />
                                                    <span className="error_content">
                                                        {minAdIsRequiredError && <>This field is required <br /></>}
                                                        {minAdValueRangeError && <>Value must be between 1 and 500</>}</span>
                                                </div>
                                                <div className='divider_d2'>-</div>
                                            </Col>
                                            <Col span={12}>
                                                <div className="form_content_block--group mb_0">
                                                    <label className="form_label invisible">Per *</label>
                                                    <Input className={maxAdIsRequiredError || maxAdValueRangeError || maxAdValueError ? 'form_control basic error' : 'form_control basic'} autocomplete="off" placeholder='To' suffix={
                                                        <em className='input_inside_text_d2'>second(s)</em>
                                                    }

                                                        value={maxAd}
                                                        onChange={onChangeMaxAd}
                                                    />
                                                    <span className="error_content">
                                                        {maxAdIsRequiredError && <>This field is required <br /> </>}
                                                        {maxAdValueRangeError && <>Value must be between 1 and 500 <br /></>}
                                                        {maxAdValueError && <>Min Ad duration must be smaller  than max Ad duration </>}
                                                    </span>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                            </Row>
                            :
                            <>

                                {site_pubmatic !== "" ?
                                    <Row gutter={16}>
                                        <Col span={8}>
                                            <div className="container_box--label-info">
                                                <label>Ad Size</label>
                                            </div>
                                        </Col>

                                        <Col span={16}>
                                            <div className="container_box--form-container">
                                                <div className="form_content_block--group">
                                                    <div className="form_content_block--group  hide_caret_after_select_value">
                                                        <label className="form_label">Primary Ad Size * </label>
                                                        <Select
                                                            showSearch
                                                            className='form_select basic '
                                                            placeholder="-Select-"
                                                            optionFilterProp="label"
                                                            onChange={onChangeAdSizePrimary_pubmatic}
                                                            value={adSizePrimary_pubmatic}
                                                            options={[
                                                                ...adSizePrimaryOptions_pubmatic.filter(option => option.value === adSizePrimary_pubmatic),   // First, display checked options
                                                                ...adSizePrimaryOptions_pubmatic.filter(option => option.value !== adSizePrimary_pubmatic),  // Then, display unchecked options
                                                            ]}
                                                        />
                                                        <span className="error_content"> </span>
                                                    </div>
                                                </div>
                                                <div className="form_content_block--group">
                                                    <div className='checkbox_value_select_d2 multi_select_tag_d2'>
                                                        <label className="form_label">Additional Ad Size </label>
                                                        <Select
                                                            id="adSizeAdditional"
                                                            value={adSizeAdditional_pubmatic}
                                                            popupClassName='diff_select_d2 --full'
                                                            // open={true}
                                                            showSearch={false}
                                                            placeholder='- Select -'
                                                            className={adSizeAdditionalValidError_pubmatic ? "form_select basic error" : "form_select basic"}
                                                            mode='multiple'
                                                            maxTagCount='responsive'
                                                            dropdownRender={menu => (
                                                                <>
                                                                    <div className="custom_inside_searchbar_d2">
                                                                        <Input placeholder="Search"
                                                                            value={searchValueAdSizeAdditional} onChange={handleSearchAdSizeAdditional}
                                                                            prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                                    </div>
                                                                    {/* <div className='select_all_d2'
                                                                        onClick={() => handleSelectAllAdSizeAdditional()}
                                                                    >
                                                                        <Checkbox checked={adSizeAdditional_pubmatic?.length === adSizeAdditionalOptions_pubmatic?.length} onClick={(e) => e.stopPropagation()}>
                                                                            Select All
                                                                        </Checkbox>
                                                                    </div> */}
                                                                    {menu}
                                                                </>
                                                            )}
                                                        >
                                                            {[
                                                                ...filteredOptionsAdSizeAdditional?.filter(option => adSizeAdditional_pubmatic?.includes(option.value)), // Checked options first
                                                                ...filteredOptionsAdSizeAdditional?.filter(option => !adSizeAdditional_pubmatic?.includes(option.value)) // Unchecked options next
                                                            ].map(option => (
                                                                <Option key={option.value} value={option.value}>
                                                                    <div
                                                                        onClick={() => handleChangeAdSizeAdditional(option.value)}
                                                                        style={{ display: 'flex', alignItems: 'center' }}
                                                                    >
                                                                        <Checkbox
                                                                            checked={adSizeAdditional_pubmatic.includes(option.value)}
                                                                            onClick={(e) => e.stopPropagation()}
                                                                        >
                                                                            {option.label}
                                                                        </Checkbox>
                                                                    </div>
                                                                </Option>
                                                            ))}
                                                        </Select>
                                                        <span className="error_content">
                                                            {adSizeAdditionalValidError_pubmatic && <>Selection can not be greater than 9</>}
                                                        </span>
                                                    </div>
                                                </div>
                                                {/* <div className="form_content_block--group">
                                                    <div className="form_content_block--group  hide_caret_after_select_value">
                                                        <label className="form_label"> Additional Ad Size </label>
                                                        <Select
                                                            showSearch
                                                            className='form_select basic '
                                                            placeholder="-Select-"
                                                            optionFilterProp="label"
                                                            onChange={onChangeAdSizeAdditional_pubmatic}
                                                            value={adSizeAdditional_pubmatic}
                                                            options={adSizeAdditionalOptions_pubmatic.filter(option => option.value !== adSizePrimary_pubmatic)}
                                                        />

                                                    </div>
                                                </div> */}
                                            </div>
                                        </Col>
                                    </Row>
                                    :
                                    <></>
                                }
                            </>
                        }

                        <Row gutter={16}>
                            <Col span={8}>
                                <div className="container_box--label-info">
                                    <label>Basic Details</label>
                                </div>
                            </Col>

                            <Col span={16}>
                                <div className="container_box--form-container">
                                    <Row gutter={16}>
                                        <Col span={24}>
                                            <div className="form_content_block--group mb-0 hide_caret_after_select_value">
                                                <label className="form_label">Ad Tag Name * </label>
                                                <Input className={tagNameIsRequiredError_pubmatic ? 'form_control basic error ' : 'form_control basic '} autocomplete="off"
                                                    value={tagName_pubmatic}
                                                    onChange={onChangeTagName_pubmatic}
                                                    onBlur={onBlurTagName_pubmatic}
                                                />
                                                <span className="error_content">
                                                    {tagNameIsRequiredError_pubmatic && <>This field is required</>}
                                                </span>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <div className="hr_custom mb_20"></div>
                    <div className="btn_group justify-content-end gap_8 pb_50">
                        {buttonProcessing ?
                            <>
                                <button className="w_120_d2 btn btn_white_outline w_fit_content"
                                    disabled
                                >
                                    Discard
                                </button>
                                <button
                                    className="w_120_d2 btn btn_primary w_fit_content loader"

                                >
                                    <span>Create Tag</span>

                                    <img
                                        src={loaderIcon}
                                        alt="USP"
                                        className="loader_icon"
                                    />
                                </button>
                            </> :
                            <>
                                <button className="w_120_d2 btn btn_white_outline w_fit_content"
                                    onClick={() => {
                                        handlePageViewChange("table", "no")
                                    }}
                                > Discard </button>
                                <button className="w_120_d2 btn btn_primary w_fit_content"
                                    onClick={handleSubmit}
                                >Create Tag</button>
                            </>
                        }

                    </div>
                </div>
            </div >
        </>
    )
}

export default TagCreatePubmatic
